import { render } from "./WhatsappSettingsForm.vue?vue&type=template&id=fa5fc7e2&scoped=true"
import script from "./WhatsappSettingsForm.vue?vue&type=script&lang=js"
export * from "./WhatsappSettingsForm.vue?vue&type=script&lang=js"

import "./WhatsappSettingsForm.vue?vue&type=style&index=0&id=fa5fc7e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5fc7e2"]])

export default __exports__